module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field has-addons",
    staticStyle: {
      "justify-content": "flex-end",
      "padding-top": "1.5rem"
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.value <= 0
    },
    on: {
      "click": function($event) {
        return _vm.buttonClick(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.rightDisabled
    },
    on: {
      "click": function($event) {
        return _vm.buttonClick(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a71ac82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginator.vue
// module id = 145
// module chunks = 1